import React, { useEffect, useRef } from 'react';
import { gsap } from '../../lib/gsap';
import './Cursor.css';

function Cursor() {
  const ringRef = useRef(null);
  const dotRef = useRef(null);

  useEffect(() => {
    const isTouch = matchMedia('(pointer: coarse)').matches || matchMedia('(hover: none)').matches;
    if (isTouch) return undefined;

    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ring = ringRef.current;
    const dot = dotRef.current;
    if (!ring || !dot) return undefined;

    let mouseX = 0;
    let mouseY = 0;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const raf = () => {
      if (reduceMotion) {
        gsap.set(ring, { x: mouseX, y: mouseY });
        gsap.set(dot, { x: mouseX, y: mouseY });
      } else {
        gsap.to(ring, { x: mouseX, y: mouseY, duration: 0.35, ease: 'power2.out' });
        gsap.to(dot, { x: mouseX, y: mouseY, duration: 0.08, ease: 'power2.out' });
      }
    };

    const onEnter = () => ring.classList.add('cursor-hover');
    const onLeave = () => ring.classList.remove('cursor-hover');

    const interactives = 'a, button, [role="button"], .cta-pill, .cta-secondary, .social-chip, .nav-toggle, .project-slide-tag';

    document.addEventListener('mousemove', onMove);
    gsap.ticker.add(raf);

    const addListeners = () => {
      document.querySelectorAll(interactives).forEach((el) => {
        el.addEventListener('mouseenter', onEnter);
        el.addEventListener('mouseleave', onLeave);
      });
    };

    addListeners();
    const observer = new MutationObserver(addListeners);
    observer.observe(document.body, { childList: true, subtree: true });

    document.body.classList.add('has-custom-cursor');

    return () => {
      document.removeEventListener('mousemove', onMove);
      gsap.ticker.remove(raf);
      observer.disconnect();
      document.querySelectorAll(interactives).forEach((el) => {
        el.removeEventListener('mouseenter', onEnter);
        el.removeEventListener('mouseleave', onLeave);
      });
      document.body.classList.remove('has-custom-cursor');
    };
  }, []);

  return (
    <>
      <div className="cursor-ring" ref={ringRef} aria-hidden="true" />
      <div className="cursor-dot" ref={dotRef} aria-hidden="true" />
    </>
  );
}

export default Cursor;
